"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ConsentSelectorExplicit_1 = require("./ConsentSelectorExplicit");
var ConsentSelectorCheckbox_1 = require("./ConsentSelectorCheckbox");
exports.ConsentSelector = function (_a) {
    var formData = _a.formData;
    var _b;
    return ((_b = formData.schema) === null || _b === void 0 ? void 0 : _b.explicitConsent) ? (<ConsentSelectorExplicit_1.default formData={formData}/>) : (<ConsentSelectorCheckbox_1.default formData={formData}/>);
};
exports.default = exports.ConsentSelector;
